import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./components";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { bellaTchauTheme } from "./constantes";
import { defaultTheme } from "./theme";
import { StoreProvider } from "./components/contexts/store-provider.context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider>
    <StoreProvider>
      <BrowserRouter>
        <ThemeProvider theme={defaultTheme(bellaTchauTheme)}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </StoreProvider>
  </AuthProvider>
);
